module.exports = __webpack_public_path__ + "static/media/medical.acd0cc44.jpeg";